<div fxLayout="column" fxLayoutAlign="start center">
  <mat-spinner [diameter]="25"></mat-spinner>
</div>
